import axios from "axios";
import { baseURL, client,apnData ,apnData2 } from "./api";

let config = {
  baseURL,
};
function formatDateTo(date) {
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  return new Date(date).toLocaleDateString('en-US', options);
}
export const addCahierData = async (payload) => {
  payload={...payload,...payload.typeData}
  return await client.post("cachier/addCachier", apnData2(payload));
};

export const getPaymentMadeInOption = async () => {
  return await client.get(`cachier/getPaymentMadeInOptions`);
};

export const getCashTransactionInput = async () => {
  return await client.get(`cachier/getCashTransactionInput`);
};

export const getAllCachier = async () => {
  return await client.get("cachier/getCachier");
};

export const getFilterCahierData = async (campaignId, startDate="01/01/2000",endDate=formatDateTo(new Date())) => {
  return await client.get(
    `cachier/getFilterCachier?campaignId=${campaignId}&startDate=${startDate}&endDate=${endDate}`
  );
};
export const getStockPdf = async (campaignId,startDate="01/01/2000",endDate=formatDateTo(new Date())) => {
  return await client.get(`report-pdf/cachier-sheet?campaignId=${campaignId}&startDate=${startDate}&endDate=${endDate}`);
}
export const getFilterCahierByType = async ( {campaignId, filterType} ) => {
  console.log(campaignId, filterType)
  return await client.get(
    `cachier/getFilterCahierByType?campaignId=${campaignId}&filterType=${filterType}`
  );
};

export const updateCahierData = async (payload) => {
  payload={...payload,...payload.typeData}
  return await client.put("cachier/updateCachier", apnData2(payload));
};

export const getCachierReport = async () => {
  return await client.get("cachier/cachierReport")
}
export const deleteCahierData = async (payload) => {
  return await client.delete("cachier/deleteCachier", payload)
};

export const getSingleSeedCahierReport = async (seedId) => {
  return await client.get(`/cachier/seedCachierReport?SeedId=${seedId}`)
}
